import type { CelebrationKind } from './celebrations';
import type { StickerKind } from './stickers';
import type { NameStickerInfo, StatsStickerInfo } from './text-stickers';

// ── Layouts ────────────────────────────────────────────────────────────────────
// The layouts the advanced editor steps through with its arrows. **A layout is
// a set of stickers put down ready-placed** (user feedback 2026-11-03), on a
// background of its own: picking one puts its stickers where it wants them,
// and from there they are moved, sized, taken off and added to like any.

/**
 * `none` ("Blank") is the media alone, the default; `info` the climb's name,
 * its gym and its stats, on gradients that keep them legible; `cover`
 * ("Photo") the climb's card alone, growing to fill the frame for the ending
 * (user feedback 2026-11-03).
 */
export type TemplateId = 'none' | 'info' | 'cover';

/** The stickers each layout puts down, in the order they are drawn: the last on top. */
export const TEMPLATE_STICKERS: Record<TemplateId, StickerKind[]> = {
  none: [],
  info: ['stats', 'name', 'gym'],
  cover: ['card'],
};

/**
 * The effects a layout puts on a video, all starting `ENDING_LEAD_SECONDS`
 * before the end it is cut at (user feedback 2026-11-03): on Photo, the card
 * growing to fill the frame for the ending.
 */
export const TEMPLATE_CELEBRATIONS: Record<TemplateId, CelebrationKind[]> = {
  none: [],
  info: [],
  cover: ['zoom'],
};
export const ENDING_LEAD_SECONDS = 4;

/** What the stickers made of the climb's words, and the gym's, are drawn from. */
export interface TemplateRenderData {
  name: NameStickerInfo;
  stats: StatsStickerInfo;
  locationName: string;
  gymAvatar: HTMLImageElement | null;
}

/**
 * The layout's background, under its stickers: on Info, the top and the bottom
 * of the media darkened, so white words stay legible on a white wall. Photo's
 * card needs none.
 */
export function drawTemplate(ctx: CanvasRenderingContext2D, W: number, H: number, template: TemplateId) {
  if (template !== 'info') return;
  ctx.save();
  const top = ctx.createLinearGradient(0, 0, 0, H * 0.22);
  top.addColorStop(0, 'rgba(0,0,0,0.75)');
  top.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = top;
  ctx.fillRect(0, 0, W, H * 0.22);

  const bottom = ctx.createLinearGradient(0, H * 0.5, 0, H);
  bottom.addColorStop(0, 'rgba(0,0,0,0)');
  bottom.addColorStop(1, 'rgba(0,0,0,0.72)');
  ctx.fillStyle = bottom;
  ctx.fillRect(0, H * 0.5, W, H * 0.5);
  ctx.restore();
}
